import { Badge, Box, Button, CircularProgress, Fade, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdateItem } from './hooks/useUpdateItem';

const UpdateItem = ({ data, setUpdatesList}) => {
  const { t } = useTranslation();
  const { handleDownload, downloadState } = useUpdateItem(setUpdatesList, data);

  const handleButtonContent = () => {
    let content;
    if (downloadState.isPreparing) {
      content = <CircularProgress size="35px" />;
    } else if (downloadState.isDownloading) {
      content = (
        <Box sx={{position: 'relative'}} display="flex" alignItems="center">
          <CircularProgress variant="determinate" value={downloadState.downloadProgress} size="35px"/>
          <Typography variant="caption" color='#637381' sx={{position:'absolute', right: '50%' , transform: 'translateX(50%)'}}>{`${downloadState.downloadProgress}%`}</Typography>
        </Box>
      );
    } else if (downloadState.isInstalled) {
      content = t('Update Installed');
    } else {
      content = t('Download');
    }

    return content;
  };

  return (
    <Box
      sx={{
        py: 1.5,
        px: 1,
        borderRadius: 1,
        backgroundColor: '#F4F3FD',
        borderBottom: '3px solid #e5e3fc',
        overflow: 'hidden',
        '&:not(:first-child)': {
          mt: '8px',
        },
      }}
    >
      <Stack direction={'row'} alignItems={'center'} sx={{ mb: 1 }}>
        <Typography variant="body2" fontWeight={500}>
          {data.Name}
        </Typography>
        <Fade in={data.isNew} timeout={1000}>
          <Badge badgeContent={'New'} color="error" sx={{ ml: 4 }} />
        </Fade>
      </Stack>

      <Stack direction={'row'}>
        <Typography variant="caption" fontWeight={500}>
          {`${t('Size')}:`}
        </Typography>
        <Typography variant="caption" sx={{ ml: 1 }}>{`${data.SizeMB} MB`}</Typography>
      </Stack>

      <Stack direction={'row'}>
        <Typography variant="caption" fontWeight={500}>
          {`${t('Version')}:`}
        </Typography>
        <Typography variant="caption" sx={{ ml: 1 }}>
          {data.Version}
        </Typography>
      </Stack>

      <Stack direction={'row'}>
        <Typography variant="caption" fontWeight={500}>
          {`${t('Description')}:`}
        </Typography>
        <Typography variant="caption" sx={{ ml: 1 }}>
          {t(data.Description)}
        </Typography>
      </Stack>

      <Button
        variant="contained"
        size="medium"
        fullWidth
        sx={{ mt: 2 }}
        onClick={() => handleDownload(data.Id)}
        disabled={downloadState.isPreparing || downloadState.isDownloading || downloadState.isInstalled}
      >
        {handleButtonContent()}
      </Button>
    </Box>
  );
};

export default UpdateItem;
